import React from 'react';
import PropTypes from 'prop-types';
import {InlineBlocks} from 'react-tinacms-inline';
import PageBlock from './PageBlock';
import {Paragraph} from '../Paragraph';
import {Title} from '../Title';
import {pageBlockFields} from '../../constants/fields/fields';
import {Features} from '../Feature';
import {Buttons} from '../ButtonActions';
import {Images} from '../Image';
import {Image} from '../Image/Image';
import {verticalBlockTemplate} from '../../constants/templates/verticalBlock';

const BLOCKS = {
  paragraph: Paragraph,
  title: Title,
  features: Features,
  buttons: Buttons,
  images: Images,
  image: Image,
};

const VerticalComponent = (props) => {
  return (
    <PageBlock {...props}>
      <InlineBlocks name={'blocks'}
        itemProps={props.data?.itemProps}
        blocks={BLOCKS}/>
    </PageBlock>
  );
};

export const VerticalBlock = {
  Component: VerticalComponent,
  template: {
    _template: 'vertical',
    label: 'Vertical Block',
    defaultItem: verticalBlockTemplate,
    fields: pageBlockFields
  },
};

VerticalComponent.propTypes = {
  data: PropTypes.object
};
